import { DocumentReference } from './document-reference';
import { Document } from './document';
import { Gender } from '../enums';

export class Member extends Document {
    id?: string;
    church: DocumentReference;
    dateOfBirth?: Date;
    fatherOfConfession: DocumentReference;
    firstName: string;
    gender: Gender;
    isActive: boolean;
    isDeleted: boolean;
    lastName: string;
}
